import { stripIndent } from 'common-tags';
import { addDays, set } from 'date-fns';
import { SubscriptionIncomingRebill } from './components/SubscriptionRebillIncoming';
export const subscriptionRebillIncomingEmailTemplate = {
  label: 'Subscription rebill incoming',
  description: 'Sent 3 days before the next subscription billing',
  icon: 'BankCardLine',

  component: SubscriptionIncomingRebill,

  defaultTemplate: {
    name: 'Subscription rebill incoming',
    subject: {
      en: '{{ subscriptionAmount }} will be debited from your card on {{ nextBillingDate }}',
      fr: 'Un prélèvement de {{ subscriptionAmount }} est prévu le {{ nextBillingDate }}',
      it: '{{ subscriptionAmount }} verrà addebitato sulla tua carta il {{ nextBillingDate }}',
      es: '{{ subscriptionAmount }} se cargará en tu tarjeta el {{ nextBillingDate }}',
      de: '{{ subscriptionAmount }} wird am {{ nextBillingDate }} von Ihrer Karte abgebucht',
    },

    templateVariables: {
      subscription_rebill_upcoming: {
        body: {
          en: stripIndent`
            <p>Dear customer,</p>
            <p>
              You subscribed to our offer "{{ subscriptionName }}", and will
              be debited of {{ subscriptionAmount }} on {{ nextBillingDate }}
            </p>
          `,
          fr: stripIndent`
            <p>Chère cliente, cher client,</p>
            <p>
              Vous avez souscrit à notre offre « {{ subscriptionName }} », et
              un montant de {{ subscriptionAmount }} sera prélevé
              sur votre carte le {{ nextBillingDate }}.
            </p>
          `,
          it: stripIndent`
            <p>Gentile cliente,</p>
            <p>
              Ha sottoscritto la nostra offerta "{{ subscriptionName }}", e un importo
              di {{ subscriptionAmount }} verrà addebitato sulla sua
              carta il {{ nextBillingDate }}.
            </p>
          `,
          es: stripIndent`
            <p>Estimado/a cliente,</p>
            <p>
              Ha suscrito nuestra oferta "{{ subscriptionName }}", y se cargará
              un importe de {{ subscriptionAmount }} en su tarjeta el {{ nextBillingDate }}.
            </p>
          `,
          de: stripIndent`
            <p>Sehr geehrte Kundin, sehr geehrter Kunde,</p>
            <p>
              Sie haben unser Angebot „{{ subscriptionName }}“ abonniert,
              und {{ subscriptionAmount }} wird am {{ nextBillingDate }} von
              Ihrer Karte abgebucht.
            </p>
          `,
        },
      },
    },
  },

  variables: [
    { key: 'customerFirstName', label: 'Customer First Name', example: 'John' },
    { key: 'customerLastName', label: 'Customer Last Name', example: 'Doe' },
    { key: 'customerEmail', label: 'Customer Email', example: 'john@example.com' },
    { key: 'storeName', label: 'Store Name', example: 'My Store' },
    { key: 'subscriptionAmount', label: 'Subscription Amount', example: '$19.99' },
    { key: 'subscriptionName', label: 'Subscription Name', example: 'VIP Club' },
    { key: 'nextBillingDate', label: 'Billing Date', example: 'June 30, 2025' },
    { key: 'customerPortalLink', label: 'Customer Portal Link', example: 'https://...' },
  ],

  utmParameters: {
    utmSource: 'subscription_rebill',
    utmMedium: 'email',
  },

  specificParams: undefined,
  // specificParams: {
  //   triggerTimeBeforeBilling: {
  //     type: 'select',
  //     label: 'Time before billing (max 3 days)',
  //     default: '3d',
  //     options: [
  //       { value: '3d', label: '3 days' },
  //       { value: '2d', label: '2 days' },
  //       { value: '1d', label: '1 day' },
  //     ],
  //   },
  // },
  mockData: (storeName = 'Demo Store') => ({
    store: {
      id: 'store_preview',
      name: storeName,
      baseCurrency: 'USD',
      presentmentCurrencies: ['USD'],
      chargeCurrencies: ['USD'],
    },
    customer: {
      firstName: 'John',
      lastName: 'Doe',
      email: 'john@example.com',
      locale: 'en-US',
      currency: 'USD',
    },
    subscription: {
      currency: 'USD',
      product: { name: 'VIP Club' },
      price: { currencyOptions: { USD: { amount: 999 } } },
      nextBillingDate: set(addDays(new Date(), 3), { hours: 12, minutes: 0, seconds: 0, milliseconds: 0 }),
    },
    cmsRoutes: [
      { type: 'club', path: '/club', customDomain: null, cmsSubdomain: 'store_preview', active: true },
    ],
  }),

  defaultMessages: {
    promotion_title: 'Your Special Offer',
    promotion_subtitle: 'Use this code for your next purchase',
    cta_button: 'Shop Now',
    footer_text: '© 2024 All rights reserved',
  },
};
